import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../config';

function IndicationsPage() {
  const navigate = useNavigate();
  const [indications, setIndications] = useState([]);
  const [loading, setLoading]         = useState(true);
  const [error, setError]             = useState(null);
  const [search, setSearch]           = useState('');

  useEffect(() => {
    axios.get(`${API_BASE_URL}/indications`)
      .then(res => setIndications(res.data || []))
      .catch(() => setError('Failed to load indications.'))
      .finally(() => setLoading(false));
  }, []);

  function handleIndicationClick(indication) {
    navigate(`/pipeline?indication_id=${indication.id}`);
  }

  const filtered = indications.filter(ind =>
    ind.name?.toLowerCase().includes(search.toLowerCase()) ||
    ind.category?.toLowerCase().includes(search.toLowerCase()) ||
    ind.therapeutic_area?.toLowerCase().includes(search.toLowerCase())
  );

  const grouped = filtered.reduce((acc, ind) => {
    const group = ind.therapeutic_area || ind.category || 'Other';
    if (!acc[group]) acc[group] = [];
    acc[group].push(ind);
    return acc;
  }, {});

  const sortedGroups = Object.keys(grouped).sort();

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Indications</h1>
        <p className="page-subtitle">
          {loading ? 'Loading…' : `${filtered.length} indication${filtered.length !== 1 ? 's' : ''}. Click any to filter the pipeline.`}
        </p>
      </div>

      <div className="page-body">
        <div className="filter-bar">
          <input
            type="text"
            placeholder="Search indications…"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>

        {error && <div className="error-state">{error}</div>}
        {loading && <div className="loading-state">Loading indications…</div>}

        {!loading && !error && filtered.length === 0 && (
          <p style={{ color: '#94a3b8', padding: '32px 0' }}>No indications found.</p>
        )}

        {!loading && !error && filtered.length > 0 && (
          sortedGroups.length === 1 && sortedGroups[0] === 'Other' ? (
            <div className="indication-list">
              {filtered.map(ind => (
                <IndicationRow key={ind.id} ind={ind} onClick={() => handleIndicationClick(ind)} />
              ))}
            </div>
          ) : (
            sortedGroups.map(group => (
              <div key={group} style={{ marginBottom: 24 }}>
                <div style={{
                  fontSize: 11,
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  letterSpacing: '0.7px',
                  color: '#64748b',
                  marginBottom: 8,
                  paddingLeft: 2,
                }}>
                  {group}
                </div>
                <div className="indication-list">
                  {grouped[group].map(ind => (
                    <IndicationRow key={ind.id} ind={ind} onClick={() => handleIndicationClick(ind)} />
                  ))}
                </div>
              </div>
            ))
          )
        )}
      </div>
    </div>
  );
}

function IndicationRow({ ind, onClick }) {
  const programCount = ind.program_count ?? ind.programs_count;
  return (
    <div className="indication-item" onClick={onClick}>
      <div>
        <div className="indication-name">{ind.name}</div>
        {(ind.category || ind.therapeutic_area) && (
          <div className="indication-category">
            {ind.therapeutic_area || ind.category}
          </div>
        )}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
        {programCount != null && (
          <span className="indication-count">{programCount}</span>
        )}
        <span style={{ color: '#cbd5e1', fontSize: 12 }}>View &rarr;</span>
      </div>
    </div>
  );
}

export default IndicationsPage;
